import React, { useContext } from "react";

import { Dialog } from "@material-ui/core";
import { Field } from "./Field";
import { LanguageContext } from "../../../../context/states/languageState";
import { AuthContext } from "../../../../context/states/authState";

const AddItem = React.memo((props) => {
  const { open, handleClose, data } = props;
  const { updatedLanguageHandler } = useContext(LanguageContext);
  const { permissionKeys } = useContext(AuthContext);
  const canEditLanguage = permissionKeys.includes("edit-language");

  const onSubmitHandler = (data) => {
    updatedLanguageHandler(data);
  };
  const modalClose = () => {
    handleClose();
    // reset({ _id: '', dialect: '' });
  };

  return (
    <React.Fragment>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
      >
        <Field
          data={data}
          handleClose={modalClose}
          handleOnSubmit={onSubmitHandler}
          canEditLanguage={canEditLanguage}
        />
      </Dialog>
    </React.Fragment>
  );
});

export default AddItem;
